<div class="shotleft-provinces-banner">
  <owl-carousel-o [options]="customOptions">
    <!-- <ng-template carouselSlide> -->
      <div class="shotleft-provinces-banner--hero bg-holder bg-overlay-50">
      <!-- <div class="shotleft-provinces-banner--hero bg-holder bg-overlay-black-50" style="background-image: url('assets/images/provincemap/WC/SAT_IMGS_WC07.jpg');"> -->
        <div class="shotleft-provinces-banner--hero bg-holder bg-overlay-black-50">
          <div class="container-fluid p-0 shotleft-provinces-banner--content">
            <div>
              <div class="col-lg-12 p-0">
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </ng-template> -->

      <ng-template carouselSlide>
        <!--<a href="https://www.southafrica.net/gl/en/travel/category/liv-golf" target="_blank" rel="noopener noreferrer" class="foundMore">-->
        <a href="/province/mpumalanga" rel="noopener noreferrer" class="foundMore">
        <div class="shotleft-provinces-banner--hero bg-holder carousel-A">
          <div class="container shotleft-provinces-banner--content">
            <div class="row justify-content-between">
            
              <!-- <div class="col-lg-5 nomargin-img justify-content-start">
                <img src="assets/images/provincemap/WC/heading.png" alt="It's your country. Enjoy it." />
              </div> -->
              <!--<div class="col-lg-4 nomargin-img d-flex justify-content-end">
                <img src="assets/images/provincemap/WC/offer.png" alt="Experiences Over Gifts. Book your baecation now! #travelwisemzansi" />
              </div> -->
            </div>
            
              <!--<div class="carousel-btn-wrapper" style="text-align: right;">
                <p class="text-white" style="font-size: 1.4rem; margin-bottom: 6px; font-weight: bold;">
                  Discover LIV Golf Experiences
                </p>

                <a href="https://www.southafrica.net/gl/en/travel/category/liv-golf"
                  target="_blank"
                  rel="noopener noreferrer">
                  <button class="btn btn-primary mt-2 mt-sm-0">
                    Find Out More
                  </button>
                </a>
              </div>-->
            
          </div>      
        </div>
        </a>
      </ng-template>
</owl-carousel-o>
</div>
    <!--<ng-template carouselSlide>
      <a href="https://example.com" target="_blank" rel="noopener noreferrer" class="foundMore"></a>
        <div class="shotleft-provinces-banner--hero bg-holder carousel-B">
          <div class="container shotleft-provinces-banner--content">
            <div class="row justify-content-between">
            </div>
          </div>
        </div>
    </ng-template>
 
    <ng-template carouselSlide>
        <div class="shotleft-provinces-banner--hero bg-holder carousel-C">
          <div class="container shotleft-provinces-banner--content">
            <div class="row justify-content-between">
            
            </div>
          </div>
        </div>
    </ng-template>-->
  

<!--
<section id="homebanner" class="page-title bg-holder bg-overlay-black-50"
  style="padding:0 0 0 0;background-image: url('assets/images/provincemap/WC/SAT_IMGS_WC07.jpg');height:50%;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="banner-image-container">
          <div style="height:420px;padding-top:130px;">
            <h1><img id="yourcountry" src="assets/images/its_your_country.svg" alt="It's your country. Enjoy it." />
            </h1>
          </div>
        </div>
        <nav aria-label="breadcrumb ">
          <ol class="breadcrumb" style="font-size: 16px;">
            <li style="margin-right:auto;" class="breadcrumb-item">
              <a href="/itinerary">
                <img style="width:14px;margin-top:0px;margin-right:20px;" src="/assets/images/left-arrow.png">
                Get out there
              </a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</section>
-->   